import React from 'react'
import withIcon from '@/components/withIcon'

const IconWateringPlants = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M25 8C25 9.657 23.657 11 22 11C20.343 11 19 9.657 19 8C19 5 22 2 22 2C22 2 25 5 25 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M10 8.00097C11.105 8.00097 12 7.10597 12 6.00097C12 4.47697 10 2.66797 10 2.66797C10 2.66797 8 4.47797 8 6.00097C8 7.10597 8.895 8.00097 10 8.00097Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M14 31.0004V26.8574"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21 20.7656C17.991 21.9496 15.514 24.1776 14 26.9996"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M18 26.95C23.606 26.444 28 21.738 28 16H22C17.582 16 14 19.582 14 24"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M14 31V20C14 16.134 10.866 13 7 13H3C3 17.079 6.055 20.438 10 20.931"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  )
}

export default withIcon(IconWateringPlants)
